module.exports = __webpack_public_path__ + "static/img/map.e9f71f97.png";